import { render, staticRenderFns } from "./securityArticle.vue?vue&type=template&id=62389ddc&scoped=true"
import script from "./securityArticle.vue?vue&type=script&lang=js"
export * from "./securityArticle.vue?vue&type=script&lang=js"
import style0 from "./securityArticle.vue?vue&type=style&index=0&id=62389ddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62389ddc",
  null
  
)

export default component.exports